import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import ScrollToTop from './ScrollToTop'
import Login from '../pages/login/Login'
import Dashboard from '../pages/dashboard/Dashboard'
import AdminUsers from '../pages/adminUsers/AdminUsers'
import PrivateRoute from './PrivateRoute'
import Category from '../pages/category/Category'
import Courses from '../pages/courses/Courses'
import Banner from '../pages/banner/Banner'
import Languages from '../pages/languages/Languages'
import TopSearch from '../pages/TopSearch/TopSearch'
import PageNotFound from '../pages/PageNotFound/PageNotFound'
import AddAdminUser from '../pages/adminUsers/AddAdminUser'
import AddLanguage from '../pages/languages/AddLanguage'
import AddCategory from '../pages/category/AddCategory'
import AddCourse from '../pages/courses/AddCourse'
import AddBanner from '../pages/banner/AddBanner'
import AddTopSearch from '../pages/TopSearch/AddTopSearch'
import Faqs from '../pages/faqs/Faqs'
import AddFaq from '../pages/faqs/AddFaq'
import Testimonials from '../pages/testimonials/Testimonials'
import AddTestimonial from '../pages/testimonials/AddTestimonial'
import Customers from '../pages/customers/Customers'
import Orders from '../pages/orders/Orders'
import Quiz from '../pages/Quiz/Quiz'
import AddQuiz from '../pages/Quiz/AddQuiz'
import AddQuestions from '../pages/Quiz/AddQuestions'
import BusinessCategory from '../pages/BusinessCategory/BusinessCategory'
import AddBusinessCategory from '../pages/BusinessCategory/AddBusinessCategory'
import Collections from '../pages/Collections/Collections'
import AddCollections from '../pages/Collections/AddCollections'
import Badges from '../pages/Badges/Badges'
import AddBadges from '../pages/Badges/AddBadges'
import ForgotPassword from '../pages/login/ForgotPassword'
import ResetPassword from '../pages/login/ResetPassword'
import AddSections from '../pages/Quiz/AddSections'
import Sections from '../pages/Quiz/Sections'
import Questions from '../pages/Quiz/Questions'
import CustomerOrders from '../pages/customers/CustomerOrders'
import HomeLayout from '../pages/HomeLayout/HomeLayout'
import AddHomeLayout from '../pages/HomeLayout/AddHomeLayout'
import Notifications from '../pages/Notifications/Notifications'
import AddNotifications from '../pages/Notifications/AddNotifications'
import AccountDeletion from '../pages/AccountDeletion/AccountDeletion'
import Scores from '../pages/Quiz/Scores'
import AddScores from '../pages/Quiz/AddScores'
import SectionScores from '../pages/Quiz/SectionScores'
import AddSectionScores from '../pages/Quiz/AddSectionScores'
import Affiliates from '../pages/Affiliates/Affiliates'
import ViewAffiliate from '../pages/Affiliates/ViewAffiliate'
import AddAffiliate from '../pages/Affiliates/AddAffiliate'
import AffiliateOrders from '../pages/Affiliates/AffiliateOrders'
import Enrolled from '../pages/Quiz/Enrolled/Enrolled'
import UserAttempts from '../pages/Quiz/Enrolled/UserAttempts'
import AffiliateUserOrders from '../pages/AffiliateUserOrders/AffiliateUserOrders'
import UserQuizResults from '../pages/Quiz/Enrolled/UserQuizResults'
import Profile from '../pages/Profile/Profile'
import QuizAttempts from '../pages/Quiz/QuizAttempts'


const Routing = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path='/login' element={<Login />}></Route>
        <Route path='/forgot-password' element={<ForgotPassword />}></Route>
        <Route path='/reset-password/:token' element={<ResetPassword />}></Route>
        <Route path='/' element={<PrivateRoute><Dashboard /></PrivateRoute>}></Route>
        <Route path='/profile' element={<PrivateRoute><Profile /></PrivateRoute>}></Route>

        <Route path='/home-layout' element={<PrivateRoute><HomeLayout /></PrivateRoute>}></Route>
        <Route path='/home-layout/add' element={<PrivateRoute><AddHomeLayout /></PrivateRoute>}></Route>
        <Route path='/home-layout/edit/:id' element={<PrivateRoute><AddHomeLayout /></PrivateRoute>}></Route>
        
        <Route path='/notifications' element={<PrivateRoute><Notifications /></PrivateRoute>}></Route>
        <Route path='/notifications/add' element={<PrivateRoute><AddNotifications /></PrivateRoute>}></Route>
        <Route path='/notifications/edit/:id' element={<PrivateRoute><AddNotifications /></PrivateRoute>}></Route>
        
        <Route path='/admin-users' element={<PrivateRoute><AdminUsers /></PrivateRoute>}></Route>
        <Route path='/admin-users/add' element={<PrivateRoute><AddAdminUser /></PrivateRoute>}></Route>
        <Route path='/admin-users/edit/:id' element={<PrivateRoute><AddAdminUser /></PrivateRoute>}></Route>
        
        <Route path='/account-deletion' element={<PrivateRoute><AccountDeletion/></PrivateRoute>}></Route>

        <Route path='/category' element={<PrivateRoute><Category /></PrivateRoute>}></Route>
        <Route path='/category/add' element={<PrivateRoute><AddCategory /></PrivateRoute>}></Route>
        <Route path='/category/edit/:id' element={<PrivateRoute><AddCategory /></PrivateRoute>}></Route>
        
        <Route path='/business-category' element={<PrivateRoute><BusinessCategory /></PrivateRoute>}></Route>
        <Route path='/business-category/add' element={<PrivateRoute><AddBusinessCategory /></PrivateRoute>}></Route>
        <Route path='/business-category/edit/:id' element={<PrivateRoute><AddBusinessCategory /></PrivateRoute>}></Route>

        <Route path='/courses' element={<PrivateRoute><Courses /></PrivateRoute>}></Route>
        <Route path='/courses/add' element={<PrivateRoute><AddCourse /></PrivateRoute>}></Route>
        <Route path='/courses/edit/:id' element={<PrivateRoute><AddCourse /></PrivateRoute>}></Route>

        <Route path='/banners' element={<PrivateRoute><Banner /></PrivateRoute>}></Route>
        <Route path='/banners/add' element={<PrivateRoute><AddBanner /></PrivateRoute>}></Route>
        <Route path='/banners/edit/:id' element={<PrivateRoute><AddBanner /></PrivateRoute>}></Route>

        <Route path='/languages' element={<PrivateRoute><Languages /></PrivateRoute>}></Route>
        <Route path='/languages/add' element={<PrivateRoute><AddLanguage /></PrivateRoute>}></Route>
        <Route path='/languages/edit/:id' element={<PrivateRoute><AddLanguage /></PrivateRoute>}></Route>

        <Route path='/top-search' element={<PrivateRoute><TopSearch /></PrivateRoute>}></Route>
        <Route path='/top-search/add' element={<PrivateRoute><AddTopSearch /></PrivateRoute>}></Route>
        <Route path='/top-search/edit/:id' element={<PrivateRoute><AddTopSearch /></PrivateRoute>}></Route>

        <Route path='/faqs' element={<PrivateRoute><Faqs /></PrivateRoute>}></Route>
        <Route path='/faqs/add' element={<PrivateRoute><AddFaq /></PrivateRoute>}></Route>
        <Route path='/faqs/edit/:id' element={<PrivateRoute><AddFaq /></PrivateRoute>}></Route>

        <Route path='/testimonials' element={<PrivateRoute><Testimonials /></PrivateRoute>}></Route>
        <Route path='/testimonials/add' element={<PrivateRoute><AddTestimonial /></PrivateRoute>}></Route>
        <Route path='/testimonials/edit/:id' element={<PrivateRoute><AddTestimonial /></PrivateRoute>}></Route>
        
        <Route path='/quiz' element={<PrivateRoute><Quiz /></PrivateRoute>}></Route>
        <Route path='/quiz/add' element={<PrivateRoute><AddQuiz /></PrivateRoute>}></Route>
        <Route path='/quiz/edit/:id' element={<PrivateRoute><AddQuiz /></PrivateRoute>}></Route>
        
        <Route path='/quiz/:quizId/attempts' element={<PrivateRoute><QuizAttempts /></PrivateRoute>}></Route>
        <Route path='/quiz/:quizId/attempts/:attemptId' element={<PrivateRoute><UserQuizResults route={'quiz-result'} /></PrivateRoute>}></Route>
        
        <Route path='/quiz/:quizId/enrolled-users' element={<PrivateRoute><Enrolled /></PrivateRoute>}></Route>
        <Route path='/quiz/:quizId/enrolled-users/:id' element={<PrivateRoute><UserAttempts /></PrivateRoute>}></Route>
        <Route path='/quiz/:quizId/enrolled-users/:id/results/:attemptId' element={<PrivateRoute><UserQuizResults route={'quiz'} /></PrivateRoute>}></Route>

        <Route path='/quiz/:quizId/scores/' element={<PrivateRoute><Scores /></PrivateRoute>}></Route>
        <Route path='/quiz/:quizId/scores/add' element={<PrivateRoute><AddScores /></PrivateRoute>}></Route>
        <Route path='/quiz/:quizId/scores/edit/:id' element={<PrivateRoute><AddScores /></PrivateRoute>}></Route>
        
        <Route path='/quiz/:quizId/section/' element={<PrivateRoute><Sections /></PrivateRoute>}></Route>
        <Route path='/quiz/:quizId/section/add' element={<PrivateRoute><AddSections /></PrivateRoute>}></Route>
        <Route path='/quiz/:quizId/section/edit/:id' element={<PrivateRoute><AddSections /></PrivateRoute>}></Route>
        
        <Route path='/quiz/:quizId/section/:sectionId/scores/' element={<PrivateRoute><SectionScores /></PrivateRoute>}></Route>
        <Route path='/quiz/:quizId/section/:sectionId/scores/add' element={<PrivateRoute><AddSectionScores /></PrivateRoute>}></Route>
        <Route path='/quiz/:quizId/section/:sectionId/scores/edit/:id' element={<PrivateRoute><AddSectionScores /></PrivateRoute>}></Route>
        
        <Route path='/quiz/:quizId/section/:sectionId/questions' element={<PrivateRoute><Questions /></PrivateRoute>}></Route>
        <Route path='/quiz/:quizId/section/:sectionId/questions/add' element={<PrivateRoute><AddQuestions /></PrivateRoute>}></Route>
        <Route path='/quiz/:quizId/section/:sectionId/questions/edit/:id' element={<PrivateRoute><AddQuestions /></PrivateRoute>}></Route>

        <Route path='/collections' element={<PrivateRoute><Collections /></PrivateRoute>}></Route>
        <Route path='/collections/add' element={<PrivateRoute><AddCollections /></PrivateRoute>}></Route>
        <Route path='/collections/edit/:id' element={<PrivateRoute><AddCollections /></PrivateRoute>}></Route>
        
        <Route path='/badges' element={<PrivateRoute><Badges /></PrivateRoute>}></Route>
        <Route path='/badges/add' element={<PrivateRoute><AddBadges /></PrivateRoute>}></Route>
        <Route path='/badges/edit/:id' element={<PrivateRoute><AddBadges /></PrivateRoute>}></Route>
        
        <Route path='/affiliates' element={<PrivateRoute><Affiliates /></PrivateRoute>}></Route>
        <Route path='/affiliates/add' element={<PrivateRoute><AddAffiliate /></PrivateRoute>}></Route>
        <Route path='/affiliates/edit/:id' element={<PrivateRoute><AddAffiliate /></PrivateRoute>}></Route>
        <Route path='/affiliates/view/:id' element={<PrivateRoute><ViewAffiliate /></PrivateRoute>}></Route>
        <Route path='/affiliates/orders/:id' element={<PrivateRoute><AffiliateOrders /></PrivateRoute>}></Route>
        
        <Route path='/affiliate-orders' element={<PrivateRoute><AffiliateUserOrders /></PrivateRoute>}></Route>

        <Route path='/customers' element={<PrivateRoute><Customers /></PrivateRoute>}></Route>
        <Route path='/customers/orders/:id' element={<PrivateRoute><CustomerOrders /></PrivateRoute>}></Route>
        <Route path='/customers/orders/:id/quiz/:quizId/results/:attemptId' element={<PrivateRoute><UserQuizResults route={'customer'} /></PrivateRoute>}></Route>
        <Route path='/orders' element={<PrivateRoute><Orders /></PrivateRoute>}></Route>
        <Route path='*' element={<PageNotFound />}></Route>
      </Routes>
    </BrowserRouter>
  )
}

export default Routing
